module.exports = __webpack_public_path__ + "img/sk.dd562a96.svg";